// vim: ft=javascriptreact
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Alert,
  Button,
  Row,
  Col,
  Spinner,
} from 'react-bootstrap'
import useResident from './hooks/useResident'
import useAdmin from './hooks/useIsAdmin'
import ResidentForm from './ResidentForm'
import BookingsListing from './BookingsListing'

const Home = () => {
  const { resident, residentLoaded, nonResident } = useResident()
  const isAdmin = useAdmin()
  const navigate = useNavigate()

  useEffect(() => {
    if (isAdmin && nonResident && !resident && residentLoaded) {
      navigate('/admin')
    }
  }, [resident, residentLoaded, nonResident, isAdmin])

  return (
    <>
      <Row>
        {!nonResident && !resident && residentLoaded &&
          <Col md={8} lg={6}>
            <h2>Finish Sign Up</h2>

            <ResidentForm />
          </Col>
        }

        {!residentLoaded && <Col><Spinner /></Col>}

        {resident &&
          <Col>
            <BookingsListing
              noBookings={() => (
                <Alert variant="info" className="mb-3">
                  Once you have made a booking, it will show up here.
                </Alert>
              )}
              filterFunc={(b) => !!b.my_booking}
              activeActions={() => (
                <Row>
                  <Col>
                    <Button variant="outline-primary" onClick={() => navigate('/schedule')}>
                      <i className="fa fa-plus" />
                      {' '}
                      Add Booking
                    </Button>
                  </Col>
                </Row>
              )}
            />
          </Col>
        }
      </Row>
    </>
  )
}


export default Home
